// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Items_text-gradient__3j43B","noItemsFound":"Items_noItemsFound__2lJLs","noItemsText":"Items_noItemsText__2kKjr","loader":"Items_loader__1kuYW"};